var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"provider-list"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.data),function(item){return _c('provider-list-item',_vm._b({key:item.key},'provider-list-item',item,false))})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row-titles"},[_c('p',{staticClass:"body"},[_vm._v("ชื่อ (ที่ใช้บน SAP)")]),_vm._v(" "),_c('p',{staticClass:"body"},[_vm._v("ชื่อ (ที่ใช้บน APP)")])])
}]

export { render, staticRenderFns }